module.exports = __webpack_public_path__ + "img/join1-1.043ef8fa.jpg";